import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//客户列表
export async function getKhlistWithNoRights(params) {
    return post(erpserver+'/currency/getKhlistWithNoRights', params, true);
}
//公司企业代码
export async function getCompanyCode(params) {
    return post(erpserver+'/CreditAuthorize/getCompanyCode', params, true);
}
//汇率
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}
//列表
export async function getCreditAuthorizeList(params) {
    return post(erpserver+'/CreditAuthorize/getCreditAuthorizeList', params, true);
}

//作废
export async function invalidateCredit(params) {
    return post(erpserver+'/CreditAuthorize/invalidateCredit', params, true);
}

//baocun
export async function saveCredit(params) {
    return post(erpserver+'/CreditAuthorize/saveCredit', params, true);
}


